export const eventEndpoints = {
  resource: "/events",
  post: "",
  edit: "",
  delete: "",
  getUpcomingEvents: "/event/list",
};
